import { UserSettings } from "../../_app/types";

export function getTelegramNotificationValue(settings: UserSettings[]): boolean {
  let tgToggle = settings.find(
    (item: UserSettings) => item.name === "TELEGRAM_NOTIFICATION_ENABLED"
  );

  if (tgToggle) {
    if (tgToggle.value === "true") {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}
